import type { IconDefinition } from '../index.tsx';

export const iconCopy: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconCopy',
  icon: [16, 16, [], '', 'M0 0H10V4H4V10H0V0Z M16 6H6V16H16V6Z'],
};
